import { styled } from 'styled-components';
import { Colors, hexToRGB } from '../../../../../play-core/styles/Colors';
import { Device } from '../../../../../play-core/styles/Device';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { getMultilineTruncation } from '../../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { containerPadding } from '../../PlayContainer/PlayContainer';
export const List = styled.div.withConfig({
  displayName: "ProgramEntrystyles__List",
  componentId: "sc-71dhze-0"
})(["display:grid;grid-gap:20px;width:100%;", "{grid-gap:40px;}"], Viewports.for('mediumUp'));
export const StyledProgram = styled.div.withConfig({
  displayName: "ProgramEntrystyles__StyledProgram",
  componentId: "sc-71dhze-1"
})(["", "{margin-right:auto;}"], Viewports.for('mediumUp'));
export const ProgramDate = styled.h2.withConfig({
  displayName: "ProgramEntrystyles__ProgramDate",
  componentId: "sc-71dhze-2"
})(["color:", ";text-transform:capitalize;margin-top:20px;margin-bottom:8px;", ";", "{margin-bottom:24px;margin-top:24px;}", "{", ";}"], Colors.WHITE, Fonts.bold(24), Viewports.for('mediumUp'), Viewports.for('largeUp'), Fonts.bold(34));
export const ProgramInformation = styled.div.withConfig({
  displayName: "ProgramEntrystyles__ProgramInformation",
  componentId: "sc-71dhze-3"
})([""]);
export const Header = styled.header.withConfig({
  displayName: "ProgramEntrystyles__Header",
  componentId: "sc-71dhze-4"
})(["display:flex;align-items:center;"]);
export const ChannelImage = styled.img.withConfig({
  displayName: "ProgramEntrystyles__ChannelImage",
  componentId: "sc-71dhze-5"
})(["display:block;flex-shrink:0;margin-right:16px;margin-top:4px;margin-left:4px;height:32px;", "{position:absolute;left:0;top:0;height:20px;}", "{display:none;}"], Viewports.for('small'), ({
  hideInViewport
}) => Viewports.for(hideInViewport));
export const DateSpan = styled.span.withConfig({
  displayName: "ProgramEntrystyles__DateSpan",
  componentId: "sc-71dhze-6"
})(["color:", ";", ";line-height:28px;", "{", ";}"], Colors.WHITE, Fonts.medium(18), Viewports.for('mediumUp'), Fonts.bold(18));
export const Title = styled.h3.withConfig({
  displayName: "ProgramEntrystyles__Title",
  componentId: "sc-71dhze-7"
})(["color:", ";", ";", ";margin-top:4px;margin-bottom:4px;", "{color:", ";", ";", ";margin-top:8px;margin-bottom:8px;line-height:28px;}"], Colors.GREY_d2d2d2, getMultilineTruncation(2, 20), Fonts.medium(16), Viewports.for('mediumUp'), Colors.WHITE, getMultilineTruncation(2, 24), Fonts.medium(18));
export const SubTitle = styled.h3.withConfig({
  displayName: "ProgramEntrystyles__SubTitle",
  componentId: "sc-71dhze-8"
})(["color:", ";", ";", ";margin:4px 0;", "{", ";margin:8px 0;}"], Colors.GREY_969696, getMultilineTruncation(2, 24), Fonts.regular(16), Viewports.for('mediumUp'), Fonts.regular(16));
export const Description = styled.p.withConfig({
  displayName: "ProgramEntrystyles__Description",
  componentId: "sc-71dhze-9"
})(["", ";margin:0;color:", ";", ";", "{display:none;}"], Fonts.light(18), Colors.GREY_d2d2d2, getMultilineTruncation(3, 28), Viewports.for('small'));
export const ImageContainer = styled.div.withConfig({
  displayName: "ProgramEntrystyles__ImageContainer",
  componentId: "sc-71dhze-10"
})(["position:relative;"]);
export const Entry = styled.button.withConfig({
  displayName: "ProgramEntrystyles__Entry",
  componentId: "sc-71dhze-11"
})(["margin:-8px -", "px;padding:16px ", "px;text-transform:none;text-align:initial;display:grid;grid-template-columns:", " 700px;grid-column-gap:60px;", "{margin:-8px -", "px;padding:8px ", "px;}", "{margin:-4px -8px;padding:4px 8px;grid-template-columns:", " auto;grid-column-gap:16px;width:100%;box-sizing:content-box;}", "{&:hover{background:", ";}}"], containerPadding.large, containerPadding.large, ({
  showFirstColumn
}) => showFirstColumn ? '240px' : '', Viewports.for('medium'), containerPadding.medium, containerPadding.medium, Viewports.for('small'), ({
  showFirstColumn
}) => showFirstColumn ? '130px' : '', Device.mouse, hexToRGB(Colors.GREY_3a3a3a, 0.55));